module.exports = __webpack_public_path__ + "static/media/Cozypages.738f9b46.png";